import { SxProps } from '@mui/system'
import { theme } from 'src/providers/ThemeProvider'

type remitenteStylesType = {
  noConnected: SxProps
  noConnectedInfoIcon: SxProps
}

export const remitenteStyles: remitenteStylesType = {
  noConnected: {
    borderRadius: '4px',
    backgroundColor: theme.colors.byzantineBlue050,
    padding: theme.spacing(1, 1.5),
    color: theme.colors.gray14,
    fontFamily: theme.corporate.primaryFont,
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px'
  },

  noConnectedInfoIcon: {
    fontSize: 22,
    marginRight: theme.spacing(1)
  }
}
